import Dropdown from "react-bootstrap/Dropdown";
import DropdownItem from "react-bootstrap/esm/DropdownItem";
import DropdownMenu from "react-bootstrap/esm/DropdownMenu";
import { toggleStyle, menuStyle } from "../../data/dropdownStyles";

export default function BlockPatternsButtons(props) {
  return (
    <div style={{ display: "flex", gap: "1rem" }}>
      <Dropdown style={{ display: props.FlashRateDisplay }}>
        <Dropdown.Toggle
          style={toggleStyle}
          variant="success"
          id="dropdown-basic"
        >
          Flash Rate
        </Dropdown.Toggle>

        <Dropdown.Menu style={menuStyle}>
          <Dropdown.Item
            onClick={() => props.flashRate(0)}
            active={props.flashBool === 0}
          >
            No Flash
          </Dropdown.Item>
          <Dropdown.Item
            onClick={() => props.flashRate(2000)}
            active={props.flashBool === 2000}
          >
            2
          </Dropdown.Item>
          <Dropdown.Item
            onClick={() => props.flashRate(2500)}
            active={props.flashBool === 2500}
          >
            2.5
          </Dropdown.Item>
          <Dropdown.Item
            onClick={() => props.flashRate(3000)}
            active={props.flashBool === 3000}
          >
            3
          </Dropdown.Item>
          <Dropdown.Item
            onClick={() => props.flashRate(3500)}
            active={props.flashBool === 3500}
          >
            3.5
          </Dropdown.Item>
          <Dropdown.Item
            onClick={() => props.flashRate(4000)}
            active={props.flashBool === 4000}
          >
            4
          </Dropdown.Item>
          <Dropdown.Item
            onClick={() => props.flashRate(4500)}
            active={props.flashBool === 4500}
          >
            4.5
          </Dropdown.Item>
          <Dropdown.Item
            onClick={() => props.flashRate(5000)}
            active={props.flashBool === 5000}
          >
            5
          </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
      <Dropdown>
        <Dropdown.Toggle
          style={toggleStyle}
          variant="success"
          id="dropdown-basic"
        >
          Progression
        </Dropdown.Toggle>

        <DropdownMenu style={menuStyle}>
          <DropdownItem
            active={props.level === "Level1"}
            onClick={() => props.changeLevel("Level1")}
          >
            Level 1
          </DropdownItem>
          <DropdownItem
            active={props.level === "Level2"}
            onClick={() => props.changeLevel("Level2")}
          >
            Level 2
          </DropdownItem>
          <DropdownItem
            active={props.level === "Level3"}
            onClick={() => props.changeLevel("Level3")}
          >
            Level 3
          </DropdownItem>
        </DropdownMenu>
      </Dropdown>
    </div>
  );
}
